export const UPLOAD_LEADS_MODAL_TITLE = "Upload New List";
export const UPLOAD_LEADS_TEMPLATE_LINK =
  "https://crm-feature-configuration.s3.eu-central-1.amazonaws.com/bulk%2Badd%2Blead%2Btemplate.xlsx";
export const UPLOAD_LEADS_TEMPLATE_V2_LINK =
  "https://crm-feature-configuration.s3.eu-central-1.amazonaws.com/bulk%2Bupload%2Bleads%2Btemplate-v2.xlsx";
export const ACCEPTED_LEAD_FILE_TYPES = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

export enum BulkUploadTemplateType {
  BASIC = "basic",
  CUSTOM = "custom",
}
